export const calculateCoordinatesDistance = (
  p1: { lng: number; lat: number },
  p2: { lng: number; lat: number }
) => {
  const { lat: lat1, lng: lng1 } = p1;
  const { lat: lat2, lng: lng2 } = p2;
  // корень суммы квадратов разности координат
  return Math.sqrt(Math.pow(lat1 - lat2, 2) + Math.pow(lng2 - lng1, 2));
};
